import { IDashboardComponent, IDashboardMetadata, IDashboardSort } from '../dashboard-metadata.service';
import { LARGE_QUOTE_KPI, OPEN_STOCK_ORDERS_KPI, REPORT_4_MAPPINGS, SAT_TICKET_COLUMNS, TICKET_SORT, USER_APPROVAL_COLUMNS } from './shared-dashboard.config';
import { NumberOfFansInfoComponent } from '../info/number-of-fans-info.component';
import { CustomerDashboardFiltersComponent } from '../filters/customer/customer-dashboard-filters.component';
import { DateType } from '@app/shared/services/date.util';
import { IObject } from '@type_definitions/datatypes';
import { VALIDATOR_FN_GBDM } from '../dashboard.service';

const customerColumns:string[] = [
  'Delamcn',
  'Desprst_ds',
  'Desprnm',
  'Detimes',
  'Detimam',
  'Deoppor_ds',
  'Decatav_ds',
  'Delamst_ds',
  'Dewinch_ds',
  'Deforus',
  'Dedecdt',
  'Destadt',
  'Deopeni',
  'Decatdt',
  'Destaco',
  'Delamcm',
  'Delamnm'
];

const ALL_WEBSHOP_TYPE_EXCL_DEMO_BP: string = 'ADHOC,CEPP,P2P,REFRESH,SERVICES,SPECIAL,STEADY,DAAS,RMA';

const REPORT_21_MAPPINGS:IObject = {
  Decntce: 'country.id',
  Cucomnm: 'customerCompany.id',
  Desprnm: 'customer.id',
  Lacomco: 'lamCompany.id',
  Degbdmn: 'gbdm.id',
  Desk: 'gbdmDesk.id'
};

const REPORT_32_MAPPINGS:IObject = {
  Degbdmn: 'gbdm.id',
  Lalamnm: 'lam.id',
  Lalamcm: 'lamCompany.id',
  Desk: 'gbdmDesk.id',
  Lagrpnm: 'lamGroup.id'
};

const REPORT_107_MAPPINGS:IObject = {
  Gbdmdesk: 'gbdmDesk.id',
  Imcomnm: 'customerCompany.name'
};

const REPORT_129_MAPPINGS:IObject = {
  Shcounm: 'country.id',
  Shsprnm_ds: 'customer.id',
  Shlacom: 'lam.id',
  Shlamcn: 'lamContact.id',
  Shlamcm: 'lamCompany.id',
  Shgbdmn: 'gbdm.id'
};

const REPORT_4_SORT_BY_COUNTRY_HIT_RATE:IDashboardSort = {
  name: 'Countryhitratepercentage',
  direction: 'desc'
};

const NUMBER_OF_FANS_INFO_COMPONENT:IDashboardComponent = {
  name: NumberOfFansInfoComponent
};

const REPORT_8_INVOICE_CONFIG:{ fixedFilters:IObject; mapping:IObject<string>; columns:any[] } = {
  fixedFilters: {
    Deexpdt: '>= -5',
    Denonre_ds: 0,
    Deshort: null,
    Depayst_ds: '0,1,7,8',
    Exclude_batch_bill: 1
  },
  mapping: {
    Desprid: 'customer.id',
    Decomnm: 'customerCompany.name',
    Decouid: 'country.id',
    Ivcurce: 'currency.id'
  },
  columns: [
    'Paymentterms',
    'Deexpdt',
    'Avg_payment_terms',
    {
      name: 'Dereqid',
      label: 'ACSL #'
    },
    'Deinvid',
    'Deinvdt',
    'Depayst_ds',
    {
      name: 'Decomnm',
      label: 'Company'
    },
    'Decounm',
    'Gblname',
    'Desprnm',
    'Decommt',
    'Depayto',
    'Depaydt',
    'Depaycm'
  ]
};

export const GBDM_NEW_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'GBDM KPI NEW',
  filterComponent: {
    name: CustomerDashboardFiltersComponent,
    inputs: {
      preselectGbdm: true,
      showLamContact: true,
      preselectLamContact: true,
      preselectLamCompany: true,
      validatorFn: VALIDATOR_FN_GBDM
    }
  },
  mapping: {
    Desprnm: 'customer.id',
    Cucomid: 'customerCompany.id',
    Delamnm: 'lam.id',
    Lacomnm: 'lamCompany.id',
    Lacgrid: 'lamGroup.id',
    Gblname: 'gbdm.id',
    Decounm: 'country.id',
    Devincl: 'vatIncl.id',
    Delamcn: 'lamContact.id',
    Decurce: 'currency.id',
    Desk: 'gbdmDesk.id'
  },
  fixedFilters: {
    Devincl: '0'
  },

  groups: [
    {
      key: 'DECREASE',
      reports: [
        {
          id: 37,
          key: 'PROBLEMATIC_FEES',
          comments: 'Orders where ACSL fee is negative or where there is a LAM fee but no ACSL fee',
          fixedFilters: {
            Problemwithacclsfee: '>0',
            Deinvok: 'not',
            Deinvty: null,
            Dereqst: '3234846615',
            Totalfee: null,
            Declodt_FROM: null,
            Declodt_TO: null
          },
          mapping: {
            Delamcm: 'lamCompany.id',
            Degbdmn: 'gbdm.id'
          },
          columns: [
            'Desprnm', //Customer
            'Decounm', //Country
            'Deconti', //Geography
            'Decomnm', //BP
            'Deordnr', //Order #
            'Depornr', //Customer PO#
            'Accharg', //ACSL fee
            'Lacharg', //LAM fee
            'Superlamfee',
            'Supercustofee',
            'Superbpfee',
            'Finderfee',
            'Decredt', //Order date
            'Declodt', //Order closed date
            'Delamcm', //LAM company
            'Delamcn' //LAM contact OEM
          ]
        },
        {
          id: 211,
          key: 'WRONG_CURRENCY_ORDERS',
          comments: '',
          fixedFilters: {
            Dedate1: DateType.YESTERDAY,
            Detestr_ds: '0',
            Dewaspq: 0,
            Deordcu2_ok: 0
          }
        },
        {
          id: 56,
          key: 'WRONG_INVOICE_ADDRESS',
          mapping: {
            Degbdmn: 'gbdm.id',
            Desk: 'gbdmDesk.id'
          }
        },
        {
          id: 222,
          key: 'QUOTES_TO_BE_SENT',
          comments: 'Quotes waiting to be sent',
          fixedFilters: {
            Dereqst: 'ACSL'
          },
          mapping: {
            Decurce: 'currency.id'
          },
          columns: [
            'Devipnr_ds',
            'Dereqid',
            {
              name: 'Decompa',
              label: 'Customer'
            },
            'Decounm',
            'Desubdt',
            'Dersudt',
            'Devaldt',
            'Decommt',
            'Pacomnm',
            'Odlname',
            'Detotal',
            'Actotal',
            'Detotal',
            'Dereqst',
            'Lead_time',
            'Decompa',
            'Delamnm',
            'Lacomnm',
            'Gblname'
          ]
        },
        {
          id: 257,
          key: 'USERS_TO_APPROVE_NO_APPROVAL',
          comments: 'Customer or Vendor users without an approver',
          fixedFilters: {
            Decrety_ds: 'SIGNUP',
            Destate_ds: 'WAIT_APRVL',
            Decredt_FROM: '01/01/2018',
            Kpi: 'WITHOUT_APPROVER',
            Dashboard: 'GBDM'
          },
          mapping: {
            Owlname: 'gbdm.id',
            Decomnm: 'customerCompany.id'
          },
          columns: USER_APPROVAL_COLUMNS
        },
        {
          id: 8,
          key: 'WAITING_LAM_INVOICES',
          comments: '',
          fixedFilters: {
            Deinvty_ds: '2',
            Delednr: '600110',
            Depayst_ds: '0,1,7,8,-1'
          },
          mapping: {
            Desprid: 'customer.id',
            Decouid: 'country.id',
            Ivcurce: 'currency.id'
          },
          columns: [
            'Deinvid',
            'Deownnm',
            'Deinvnr',
            'Deinvdt',
            'Submit_date',
            'Paytobank_iban',
            'Paytobank_swift',
            'Detotal',
            'Ivcurce',
            'Depayst_ds',
            'Deperio',
            'Decommt'
          ]
        },
        {
          id: 8,
          key: 'EXPIRED_CUSTOMER_INVOICES',
          fixedFilters: REPORT_8_INVOICE_CONFIG.fixedFilters,
          mapping: REPORT_8_INVOICE_CONFIG.mapping,
          columns: REPORT_8_INVOICE_CONFIG.columns
        },
        {
          id: 8,
          key: 'RECOVERY_ARIBA_FEES',
          fixedFilters: {
            ...REPORT_8_INVOICE_CONFIG.fixedFilters,
            Owcomid: 34, // Issued by company: ACSL
            Denonre_ds: 1
          },
          mapping: {
            // overwrite root KPI mapping to null because these values irrelevant in this KPI section
            Desprnm: null,
            Cucomid: null,
            Delamnm: null,
            Lacomnm: null,
            Lacgrid: null,
            Gblname: null,
            Delamcn: null,
            Desk: null,
            Issued_by_contact: 'gbdm.fullName',
            Issued_by_contact_desk: 'gbdmDesk.id'
          },
          columns: [
            'Deinvnr',
            'Deinvdt',
            'Deduedt',
            'Deexpdt',
            'Detotal',
            'Depaydt',
            'Depaycm',
            'Decomnm',
            'Paymentterms',
            'Issued_to_email',
            'Avg_payment_terms',
            'Avg_approval_time',
            'Gblname'
          ],
          validations: [
            {
              expression: (model:IObject):boolean => !!model?.gbdmDesk?.id || !!model?.gbdm?.id,
              message: 'This section is only loaded when a GBDM desk or GBDM is selected'
            }
          ]
        },
        {
          id: 83,
          key: 'PAYMENT_PENDINGS',
          fixedFilters: {
            Decomds_txt: 'Pending - Payment',
            Dewflty: 'PO'
          },
          mapping: {
            Degbdmn: 'gbdm.id',
            Desk: 'gbdmDesk.id',
            Lalname: 'lamContact.id'
          },
          columns: [
            'Depeday', // Age
            'Dependt', // Date pending
            'Desprnm', // Customer name
            'Decommt', // Pending comment
            'Payment_status',
            'Deordnr', // ACSL #
            'Decounm', // Country
            'Owlname',// Owner (name)
            'Degbdmn',// GBDM
            'Lacomnm',// LAM company
            'Lalname',// LAM contact
            'Odlname',// OD
            'Owcnyid',// Owner type
            {
              name: 'Decredt',
              label: 'Submit date'
            }
          ]
        },
        {
          id: 85,
          key: 'EXPIRED_LOCAL_INVOICES',
          fixedFilters: {
            Deexpdt: '>=5',
            Deexpir_ds: 1,
            Deshort: null
          },
          mapping: {
            Decomnm: 'customerCompany.id',
            Lamcontact: 'lamContact.id',
            Degbdmn: 'gbdm.id'
          },
          columns: [
            'Avg_payment_terms',
            'Dereqid',
            'Depornr', // PO #
            'Desprnm',
            'Decomds',
            'Deinvnr',
            'Deinvdt',
            'Detotal', // Invoice total
            'Decurce', // Currency
            'Deconnm', // Invoice contact
            'Deemail', // Invoice email
            'Depayst_ds', // Payment status
            'Depaydt', // Payment date
            'Decommt_sh',
            {
              name: 'Decomnm',
              label: 'Company'
            },
            'Decounm',
            'Pacomnm',
            'Decodnm',
            'Degbdmn',
            'Lam',
            'Decsunm',
            'Stocktype'
          ]
        },
        {
          id: 257,
          key: 'USERS_TO_APPROVE_APPROVAL',
          comments: 'Customer or Vendor users with an approver',
          fixedFilters: {
            Decrety_ds: 'SIGNUP',
            Destate_ds: 'WAIT_APRVL',
            Decredt_FROM: '01/01/2018',
            Kpi: 'WITH_APPROVER',
            Dashboard: 'GBDM'
          },
          mapping: {
            Owlname: 'gbdm.id',
            Decomnm: 'customerCompany.id'
          },
          columns: USER_APPROVAL_COLUMNS.concat([ 'Decommt' ])
        },
        {
          id: 31,
          key: 'SUPPRESSED_EMAILS',
          storedReport: 'SUPPRESSED_USERS_GBDM',
          mapping: {
            Decomnm: 'customerCompany.id',
            Degbdmn: 'gbdm.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        },
        {
          id: 8,
          key: 'PROFORMA_CENTRAL_BILLING',
          storedReport: 'PROFORMA_INVOICES',
          fixedFilters: {
            Decomnm: 'ACSL'
          },
          mapping: {
            Desprid: 'customer.id',
            Decomnm: 'customerCompany.name',
            Decouid: 'country.id',
            Ivcurce: 'currency.id'
          }
        },
        {
          id: 107,
          key: 'ACSL_THIS_MONTH_NON_ORDER_UPLOADS',
          storedReport: 'ACSL_THIS_MONTH_NON_ORDER_UPLOADS',
          mapping: {
            Imcomnm: 'customerCompany.name',
            Gblname: null,
            Imlname: 'gbdm.fullName',
            Acsl_desk_name: 'gbdmDesk.id'
          }
        },
        {
          id: 107,
          key: 'ACSL_THIS_MONTH_ORDER_UPLOADS',
          storedReport: 'ACSL_THIS_MONTH_ORDER_UPLOADS',
          mapping: {
            Imcomnm: 'customerCompany.name',
            Gblname: null,
            Imlname: 'gbdm.fullName',
            Acsl_desk_name: 'gbdmDesk.id'
          }
        }
      ]
    },
    {
      key: 'FOLLOW_UP',
      reports: [
        {
          browselistCode: 'QUOTE_EDIT',
          key: 'LARGE_QUOTES',
          fixedFilters: LARGE_QUOTE_KPI.fixedFilters,
          mapping: {
            Degbdmn: 'gbdm.id',
            Delamco_ds: 'lam.id',
            Delamnm: 'lamContact.id',
            Desk: 'gbdmDesk.id'
          },
          columns: LARGE_QUOTE_KPI.columns,
          sort: LARGE_QUOTE_KPI.sort
        },
        {
          id: 29,
          key: 'LARGE_UNSUBMITED_ORDERS',
          fixedFilters: {
            Islargeorderorquote: 1,
            Devincl: 1
          },
          mapping: {
            Degbdmn: 'gbdm.id',
            Delamco_ds: 'lam.id',
            Desk: 'gbdmDesk.id',
            Delamnm: 'lamContact.id',
            Devincl: 'vatIncl.id'
          },
          columns: [
            'Detotal', //Total USD
            'Decredt', //Creation date
            'Desprnm', //Customer
            'Decounm', //Country
            {
              name: 'Dereqid',
              label: 'ACSL #'
            },
            {
              name: 'Depornr',
              label: 'Custo #'
            },
            'Decommt', //Status comment short
            'Dereqnm', //Requested by
            'Degbdmn', //GBDM
            'Delamco', //LAM
            'Delamnm', //LAM contact
            'Pacomnm', //BP
            'Odlname', //OD
            'Decomds', //Status
            'Deenddt' //Status date
          ],
          sort: [
            {
              name: 'Detotal',
              direction: 'desc'
            }
          ]
        },
        {
          browselistCode: 'ORDER_EDIT',
          key: 'LARGE_OPEN_ORDERS',
          fixedFilters: {
            Dewflty_ds: 'PO',
            Islargeorderorquote: 1,
            Deexuns: 1
          },
          mapping: {
            Delamco_ds: 'lam.id',
            Degbdmn: 'gbdm.id',
            Desk: 'gbdmDesk.id',
            Delamnm: 'lamContact.id'
          },
          columns: [
            'Detotal', //Total USD
            'Decredt', //Creation date
            'Desprnm', //Customer
            'Decounm', //Country
            'Dereqid', //ACSL #
            'Shstaco', //Status comment short
            'Dereqnm', //Requested by
            'Degbdmn', //GBDM
            'Delamco_ds', //LAM
            'Delamnm', //LAM contact
            'Pacomnm', //BP
            'Decodid_ds', //OD
            'Deavail', //Availability
            'Destatu', //Status
            'Destadt', //Status date
            'Deowner', //Owner
            'Veemail' //Local vendor contact email
          ],
          sort: [
            {
              name: 'Detotal',
              direction: 'desc'
            }
          ]
        },
        {
          browselistCode: 'TICKET',
          key: 'SAT_TICKETS',
          mapping: {
            Shsprnm: 'customer.id',
            Lacgrid: 'lamGroup.id',
            Shlamcm: 'lamCompany.id',
            Shlacom: 'lam.id',
            Shgbdmn: 'gbdm.id',
            Shcounm: 'country.id',
            Shlamcn: 'lamContact.id'
          },
          fixedFilters: {
            Demntty: '@SAT@'
          },
          columns: [
            'Deagebd', //Age
            'Demndid', //Ticket #
            'Delstbd', // Days last update
            'Shsprnm', // Webshop
            'Shcounm', // Country
            'Shcomnm', // Company
            'Shlname', // Requested by
            'Showlna', // Owner
            'Decount', // Nr of comments
            'Shdescr', // Subject
            'Dereqid', // ACSL #
            'Shgbdmn', // GBDM
            'Shcommt', // Last comment
            'Shlslna', // Author last comment
            'Dewtyds', // Type
            'Decnyds', // Owner type
            'Dfcnyds', // Default owner type
            'Odlname', // OD
            'Decredt_FROM', // Date created
            'Shlamcn', // LAM contact
            'Shlacom', //LAM
            'Shfcomm', // First comment
            'Shmtyds', //Category
            'Deaddco' // Add comment
          ],
          sort: TICKET_SORT
        },
        {
          id: 221,
          key: 'HIGH_PRIORITY_ITEMS',
          comments: ' ',
          fixedFilters: {
            Devipnr: 'FIRST,VIP'
          },
          mapping: {
            Desk: 'gbdmDesk.id'
          }
        },
        {
          browselistCode: 'TICKET',
          key: 'CAT_TICKETS',
          mapping: {
            Shsprnm: 'customer.id',
            Lacgrid: 'lamGroup.id',
            Shlamcm: 'lamCompany.id',
            Shlacom: 'lam.id',
            Shgbdmn: 'gbdm.id',
            Shcounm: 'country.id',
            Shlamcn: 'lamContact.id'
          },
          fixedFilters: {
            Demntty: '@CATALOGUE@'
          },
          columns: SAT_TICKET_COLUMNS,
          sort: TICKET_SORT
        },
        {
          id: 175,
          key: 'COUNTRY_HIT_RATE',
          fixedFilters: {
            Deordpr_ds: '',
            Displaycontacts: 'GAM',
            Losprst_ds: 'PRIORITY'
          },
          mapping: {
            Decusid: 'customerCompany.id',
            Delamco: 'lamCompany.id',
            Delamnm: 'lam.id'
          },
          columns: [
            'Webshopsetup',
            'Desprnm',
            'Decounm',
            'Pacomnm',
            'Deexpoy',
            'Detotal',
            'Detotlo',
            'Losprst_ds',
            'Lostaco',
            'Losprdt',
            'Denrusr',
            'Deordpr_ds',
            'Icprodt',
            'Deucnok',
            'Delamcn',
            'Cglname',
            'Gblname',
            'Improdt',
            'Derqbco',
            'Desprst_ds',
            'Destaco',
            'Deordga_ds'
          ]
        },
        {
          id: 32,
          key: 'LONG_OUTSTANDING_ORDERS',
          fixedFilters: {
            Deactio: 3234846615,
            Decredt_TO: DateType.NINETY_DAYS_AGO,
            Dewflty_ds: 'PO'
          },
          mapping: REPORT_32_MAPPINGS,
          sort: [
            {
              name: 'Age',
              direction: 'desc'
            }
          ]
        },
        {
          id: OPEN_STOCK_ORDERS_KPI.id,
          key: 'OPEN_STOCK_ORDERS', // normal orders
          fixedFilters: {
            ...OPEN_STOCK_ORDERS_KPI.fixedFilters,
            Decomds: '194', // status master stock - product delivered in stock at bp warehouse
            Destoty_ds: 'NO' // stock order type = normal order
          },
          mapping: OPEN_STOCK_ORDERS_KPI.mapping,
          storedReport: OPEN_STOCK_ORDERS_KPI.storedReport
        },
        {
          id: OPEN_STOCK_ORDERS_KPI.id,
          key: 'OPEN_STOCK_ORDERS_STOCK_TYPE', // stock orders
          fixedFilters: {
            ...OPEN_STOCK_ORDERS_KPI.fixedFilters,
            Decomds: '194,67', // status master stock - product delivered in stock at bp warehouse and shipped - received by bp
            Destoty_ds: 'NPP' // stock order type = master stock order
          },
          mapping: OPEN_STOCK_ORDERS_KPI.mapping,
          storedReport: OPEN_STOCK_ORDERS_KPI.storedReport
        },
        {
          id: 96,
          key: 'MASTER_SERVICE_PACK',
          comments: '',
          fixedFilters: {
            Decalst: 'ALLOPEN',
            Decomds: 248, // Master Service Pack
            Deorddt_FROM: null
          },
          mapping: {
            Delamco: 'lamCompany.id',
            Desk: 'gbdmDesk.id'
          }
        },
        {
          id: 32,
          key: 'HIGH_WORKLOAD_ORDERS',
          fixedFilters: {
            Deactio: 3234846615,
            Deworkl_ma: '>30',
            Deworkl: 1
          },
          mapping: REPORT_32_MAPPINGS,
          columns: [
            'Deworkl_ma', //Mails
            'Deworkl_pe', //Pendings
            'Deworkl_ti', //Tickets
            {
              name: 'Dereqid',
              label: 'ACSL #'
            },
            'Detotal', // Total USD
            'Desprnm',// Customer
            {
              name: 'Deorddt',
              label: 'Submit date'
            },
            'Destatu', // Status
            'Depladt',// Date placed
            'Deetadt',// ETA
            'Decounm',// Country
            'Pacomnm',// BP
            'Decodnm',// OD
            'Degbdmn',// GBDM
            'Destaco',// Status comments
            'Deworkl_co',// Ticket comments
            'Decredt',// Creation date
            'Lalamcm',// LAM company
            'Lalamnm'// LAM
          ],
          sort: [
            {
              name: 'Deworkl_ma',
              direction: 'desc'
            }
          ]
        },
        {
          browselistCode: 'TICKET',
          key: 'OPEN_TICKETS',
          fixedFilters: {
            Deiopen: '1',
            Dewtyds: 'TODO_TRAIN,TODO_BP,TODO_CHAT,TODO_CO,TODO_CY,TODO_INV,TODO_PO,TODO_PR'
          },
          mapping: {
            Shsprnm: 'customer.id',
            Lacgrid: 'lamGroup.id',
            Shlamcm: 'lamCompany.id',
            Shlacom: 'lam.id',
            Shcounm: 'country.id',
            Shgbdmn: 'gbdm.id',
            Shlamcn: 'lamContact.id'
          }
        },
        {
          id: 43,
          key: 'PASSED_SLA',
          fixedFilters: {
            Declodt_FROM: DateType.ONE_WEEK_AGO,
            Dedate1: null,
            Dedate2: null,
            Destadt: 1,
            Deestim: 0,
            Totsla_diff: '>0',
            Devendo_cart_show: 1,
            Dependi_show: 1
          },
          mapping: {
            Decurce: 'currency.id',
            Desprnm: 'customer.id',
            Decusid: 'customerCompany.id',
            Delamcm: 'lamCompany.id',
            Desk: 'gbdmDesk.id'
          },
          sort: [
            {
              name: 'Totsla_diff',
              direction: 'desc'
            }
          ],
          columns: [
            'Deordnr', //ACSL#
            {
              name: 'Derecdt',
              label: 'Date submitted'
            },
            'Declodt', //Date Closed
            {
              name: 'Totsla_days', //Total expected SLA
              label: 'Expected SLA'
            },
            {
              name: 'Totsla_cycle', //Total real SLA
              label: 'Real SLA'
            },
            {
              name: 'Totsla_diff', //Total Difference SLA
              label: 'Difference'
            },
            'Decloco', //Closed comment
            'Mainpendingstatus', // Main pending reason
            'Desprnm', //Webshop
            'Decounm', //Country
            'Decomnm', //BP
            'Decodnm', //OD
            'Gblname' //GBDM
          ]
        },
        {
          id: 73,
          key: 'B2B_TICKETS_OPEN',
          storedReport: 'B2B_OPEN_TICKETS',
          fixedFilters: {
            Demtyds: null // include all tickets
          },
          mapping: {
            Decomnm: 'customerCompany.id',
            Degbdmn: 'gbdm.id',
            Lam_contact_id: 'lamContact.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        },
        {
          id: 279,
          key: 'PUNCHOUTS_NO_ORDERS_LAST_7_DAYS',
          storedReport: 'PUNCHOUTS_NO_ORDERS_LAST7',
          mapping: {
            Decusid: 'customerCompany.id',
            Webshop_status: 'customer.id',
            Desprid: 'customer.id',
            Delamco_ds: 'lam.id'
          }
        }
      ]
    },
    {
      key: 'INCREASE',
      reports: [
        {
          id: 33,
          key: 'LAM_CONTACTS_STATUS',
          fixedFilters: {
            Decnyds: 'LAM',
            Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
          },
          mapping: {
            Cucomnm: 'lam.id',
            Decomnm: 'lamCompany.id',
            Degbdmn: 'gbdm.id',
            Decounm: 'country.id',
            Username: 'lamContact.id',
            Decgrid: 'lamGroup.id',
            Desprnm: 'customer.id'
          },
          columns: [
            'Deconid',
            'Defname',
            'Delname',
            'Decomnm',
            'Desprnm',
            'Detrast_ds',
            'Detradt',
            'Deacslc',
            'Delogdt',
            'Deregdt',
            'Decredt',
            'Rolecreationdate',
            'Dectitl'
          ],
          infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
        },
        {
          id: 33,
          key: 'CGAM_CONTACT_STATUS',
          comments: '',
          fixedFilters: {
            Decnyds: 'CGAM',
            Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
          },
          mapping: {
            Lam: 'lam.id',
            Lamcompany: 'lamCompany.id',
            Lamcontact: 'lamContact.id',
            Lamgroup: 'lamGroup.id',
            Desprnm: 'customer.id',
            Degbdmn: 'gbdm.id',
            Desk: 'gbdmDesk.id'
          },
          columns: [
            'Deconid',
            'Defname',
            'Delname',
            'Decomnm',
            'Desprnm',
            'Detrast_ds',
            'Detradt',
            'Deacslc',
            'Delogdt',
            'Deregdt',
            'Decredt',
            'Rolecreationdate',
            'Dectitl'
          ],
          infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
        },
        {
          id: 33,
          key: 'CUSTOMER_REFERENCE',
          comments: '',
          fixedFilters: {
            Decnyds: 'CREFERENCE',
            Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
          },
          mapping: {
            Lam: 'lam.id',
            Lamcompany: 'lamCompany.id',
            Lamcontact: 'lamContact.id',
            Lamgroup: 'lamGroup.id',
            Desprnm: 'customer.id',
            Degbdmn: 'gbdm.id',
            Desk: 'gbdmDesk.id'
          },
          columns: [
            'Deconid',
            'Defname',
            'Delname',
            'Desprnm',
            'Delogdt',
            'Detrast_ds',
            'Rolecreationdate',
            'Decounm',
            'Degrpnm',
            'Dectitl'
          ],
          infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
        },
        {
          id: 4,
          key: 'GBDM_CUSTOMER_HIT_RATE_PERCENTAGE',
          storedReport: 'GBDM_CUSTOMER_HIT_RATE_PERCENTAGE',
          mapping: REPORT_4_MAPPINGS,
          sort: [REPORT_4_SORT_BY_COUNTRY_HIT_RATE]
        },
        {
          id: 48,
          key: 'GBDM_SUCCESS_STORIES',
          storedReport: 'GBDM_SUCCESS_STORIES',
          mapping: {
            Desprnm: 'customer.id',
            Decomnm: 'customerCompany.id',
            Lalamnm: 'lam.id',
            Lalamcm: 'lamCompany.id',
            Gblname: 'gbdm.id',
            Gbdm_desk: 'gbdmDesk.id',
            Lalname: 'lamContact.id'
          }
        },
        {
          id: 107,
          key: 'OEM_THIS_MONTH_ORDER_UPLOADS',
          storedReport: 'OEM_THIS_MONTH_ORDER_UPLOADS',
          mapping: REPORT_107_MAPPINGS
        },
        {
          id: 107,
          key: 'OEM_THIS_MONTH_NON_ORDER_UPLOADS',
          storedReport: 'OEM_THIS_MONTH_NON_ORDER_UPLOADS',
          mapping: REPORT_107_MAPPINGS
        },
        {
          id: 156,
          key: 'CUSTOMERS_WITH_B2B_ORDERS',
          storedReport: 'CUSTOMERS_WITH_B2B_ORDERS',
          mapping: {
            Lalamcm: 'lamCompany.id',
            Lalamnm: 'lam.id',
            Lalname: 'lamContact.id',
            Degbdmn: 'gbdm.id'
          }
        },
        {
          id: 156,
          key: 'CUSTOMERS_WITH_B2B_INVOICES',
          storedReport: 'CUSTOMERS_WITH_B2B_INVOICES',
          mapping: {
            Degbdmn: 'gbdm.id'
          }
        },
        {
          id: 21,
          key: 'DAILY_HIT_RATE',
          storedReport: 'DAILY_HIT_RATE',
          fixedFilters: {
            Dewflty: null,
            Dedispr: null,
            Shtiest: null,
            Decurce: null,
            Devincl: null,
            Orderbyclause: null,
            Ordertotalstable: null
          },
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'DAILY_MARGIN',
          storedReport: 'DAILY_MARGIN',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'DAILY_QUOTES',
          storedReport: 'DAILY_QUOTES',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'NEW_B2B',
          storedReport: 'NEW_B2B',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'NEW_LAMS',
          storedReport: 'NEW_LAMS',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'NEW_USERS',
          storedReport: 'NEW_USERS',
          mapping: REPORT_21_MAPPINGS,
          fixedFilters: {
            Dewflty: null
          }
        },
        {
          id: 21,
          key: 'NEW_DIRECT',
          storedReport: 'NEW_DIRECT',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'NEW_SERVICES',
          storedReport: 'NEW_SERVICES',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 21,
          key: 'NEW_DIY',
          storedReport: 'NEW_DIY',
          mapping: REPORT_21_MAPPINGS
        },
        {
          id: 4,
          key: 'DAAS_ROLLOUTS',
          storedReport: 'DAAS_ROLLOUTS',
          mapping: REPORT_4_MAPPINGS
        }
      ]
    },
    {
      key: 'READ',
      reports: [
        {
          id: 108,
          key: 'MY_RECENT_MAILS',
          comments: '',
          fixedFilters: {
            Demaidt_FROM: DateType.YESTERDAY,
            Demymai: '1'

          },
          mapping: {
            Delname: 'gbdm.firstname + " " + gbdm.lastname'
          },
          columns: [
            'Deview',
            'Destate_ds',
            'Delname',
            'Wvmaito',
            'Rpsubje',
            'Dereqid',
            'Desprnm',
            'Deccoid',
            'Ermaito',
            'Ermaicc',
            'Derepor'
          ]
        },
        {
          id: 32,
          key: 'LOST_ORDERS',
          fixedFilters: {
            Deactio: 37,
            Decandt_FROM: DateType.ONE_WEEK_AGO,
            Deorddt_FROM: DateType.FIRST_OF_PREVIOUS_YEAR,
            Dewflty_ds: 'PO'
          },
          mapping: REPORT_32_MAPPINGS,
          columns: [
            'Detotal', //Total USD
            'Decredt', //Creation date
            'Desprnm', //Customer
            'Decounm', //Country
            {
              name: 'Dereqid',
              label: 'ACSL #'
            },
            {
              name: 'Depornr',
              label: 'Custo #'
            },
            'Destaco', //Status comment
            'Dereqnm', //Requested by
            'Degbdmn', //GBDM
            'Lalamnm', //LAM
            'Lalname', //LAM contact
            'Pacomnm', //BP
            'Decodnm', //OD
            'Destatu', //Status
            'Destadt', //Status date
            'Deowner' //Owner
          ],
          sort: [
            {
              name: 'Detotal',
              direction: 'desc'
            }
          ]
        },
        {
          id: 32,
          key: 'LOST_QUOTES',
          fixedFilters: {
            Deactio: 37,
            Decandt_FROM: DateType.ONE_WEEK_AGO,
            Dewflty_ds: 'PQ'
          },
          mapping: REPORT_32_MAPPINGS,
          columns: [
            'Detotal', //Total USD
            'Decredt', //Creation date
            'Desprnm', //Customer
            'Decounm', //Country
            {
              name: 'Dereqid',
              label: 'ACSL #'
            },
            {
              name: 'Depornr',
              label: 'Custo #'
            },
            'Destaco', //Status comment
            'Dereqnm', //Requested by
            'Degbdmn', //GBDM
            'Lalamnm', //LAM
            'Lalname', //LAM contact
            'Pacomnm', //BP
            'Decodnm', //OD
            'Destatu', //Status
            'Destadt', //Status date
            'Deowner' //Owner
          ],
          sort: [
            {
              name: 'Detotal',
              direction: 'desc'
            }
          ]
        },
        {
          browselistCode: 'WEBSHOP_INFO',
          key: 'MY_CUSTOMER_WITH_OPEN_ORDERS',
          comments: '',
          fixedFilters: {
            Deopeni: '>0',
            Deopenp: '1',
            Deorder: 'Delamcn, Desprnm'

          },
          mapping: REPORT_4_MAPPINGS,
          columns: customerColumns
        },
        {
          browselistCode: 'WEBSHOP_INFO',
          key: 'MY_CUSTOMER_WITHOUT_OPEN_ORDERS',
          comments: '',
          fixedFilters: {
            Desprst_ds: '@ACT@@CLOSED@@PRESALES@@STEADY@@TOAPPROVE@',
            Deopeni: '0',
            Deopenp: '1',
            Deorder: 'Delamcn, Desprnm'

          },
          mapping: REPORT_4_MAPPINGS,
          columns: customerColumns
        },
        {
          browselistCode: 'TICKET',
          key: 'CLOSED_TICKETS',
          fixedFilters: {
            Deiopen: '0',
            Dereadt_FROM: DateType.ONE_WEEK_AGO
          },
          mapping: {
            Shsprnm: 'customer.id',
            Lacgrid: 'lamGroup.id',
            Shlamcm: 'lamCompany.id',
            Shlacom: 'lam.id',
            Shcounm: 'country.id',
            Shgbdmn: 'gbdm.id',
            Shlamcn: 'lamContact.id'
          }
        },
        {
          browselistCode: 'WEBSHOP_INFO',
          key: 'MY_SLEEP_WEBSHOPS',
          comments: '',
          fixedFilters: {
            Desprst_ds: '@SLEEP@'

          },
          mapping: {
            Decurce: 'currency.id',
            Cucomnm: 'customerCompany.id',
            Delamcm: 'lamCompany.id',
            Degbdmn: 'gbdm.id',
            Decouid: 'country.id'
          },
          columns: [
            'Delamcm',
            'Delamnm',
            'Delamcn',
            'Desprnm',
            'Desprdt',
            'Desprst_ds',
            'Destaco',
            'Deopeni',
            'Desprds',
            'Degbdmn'
          ]
        },
        {
          browselistCode: 'WEBSHOP_INFO',
          key: 'LOST_WEBSHOPS',
          comments: 'Please complete reason why we lost the opportunity',
          fixedFilters: {
            Desprst_ds: '@CLOSED@',
            Desprdt_real_FROM: DateType.ONE_WEEK_AGO,
            Deopenp: '0'
          },
          mapping: {
            Decurce: 'currency.id',
            Cucomnm: 'customerCompany.id',
            Delamcm: 'lamCompany.id',
            Degbdmn: 'gbdm.id',
            Decouid: 'country.id'
          },
          columns: [
            'Desprnm',
            'Decredt',
            'Delamcm',
            'Delamcn',
            'Destaco'
          ]
        },
        {
          id: 8,
          key: 'CENTRAL_BILLING_PROFIT_CHECK',
          storedReport: 'CENTRAL_BILLING_PROFIT_CHECK',
          mapping: {
            Desprid: 'customer.id',
            Decomnm: 'customerCompany.name',
            Decouid: 'country.id',
            Ivcurce: 'currency.id'
          }
        },
        {
          id: 302,
          key: 'LOCAL_ORDERS_DECREASED_QUANTITY',
          storedReport: 'LOCAL_ORDERS_DECREASED_QUANTITY',
          mapping: {
            Gbdm_name: 'gbdm.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        },
        {
          id: 73,
          key: 'B2B_TICKETS_CLOSED',
          storedReport: 'B2B_TICKETS_CLOSED_LAST_MONTH',
          mapping: {
            Decomnm: 'customerCompany.id',
            Degbdmn: 'gbdm.id',
            Lam_contact_id: 'lamContact.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        }
      ]
    },
    {
      key: 'UPDATE',
      reports: [
        {
          id: 173,
          key: 'CGAM_MISSING',
          comments: '',
          fixedFilters: {
            Denorol: 'CGAM',
            Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
          },
          mapping: {
            Delamco: 'lamCompany.id',
            Desk: 'gbdmDesk.id',
            Gblname: 'gbdm.id',
            Lacounm: 'country.id',
            Lamgroup: 'lamGroup.id',
            Desprnm: 'customer.id',
            Decusid: 'customerCompany.id'
          }
        },
        {
          browselistCode: 'WEBSHOP_INFO',
          key: 'WAITING_FOR_CONTRACT',
          comments: '',
          fixedFilters: {
            Contractwaiting: '1'
          },
          mapping: {
            Decurce: 'currency.id',
            Cucomnm: 'customerCompany.id',
            Delamcm: 'lamCompany.id',
            Degbdmn: 'gbdm.id',
            Decouid: 'country.id'
          },
          columns: [
            'Desprnm',
            'Desprst_ds',
            'Delamcm',
            'Delamcn',
            'Culname',
            'Destadt',
            'Destaco',
            'Centralbillingpossible',
            'Delamor_ds'
          ]
        },
        {
          id: 4,
          key: 'CUSTOMERS_IN_SPOTLIGHT',
          storedReport: 'CUSTOMERS_IN_SPOTLIGHT',
          mapping: REPORT_4_MAPPINGS
        },
        {
          id: 4,
          key: 'WORKLOAD_GBDM',
          storedReport: 'WORKLOAD_GBDM',
          mapping: REPORT_4_MAPPINGS
        },
        {
          id: 4,
          key: 'MISSING_CUSTOMER_INTEL',
          storedReport: 'CUSTOMERS_PROCUREMENT_PLATFORMS',
          mapping: REPORT_4_MAPPINGS
        },
        {
          id: 54,
          key: 'CUSTOMER_SUCCESS_STORIES_WORKFLOWS',
          storedReport: 'CUSTOMER_SUCCESS_STORIES_WORKFLOWS',
          mapping: {
            Decomnm: 'customerCompany.name',
            Depronm: 'customer.id',
            Gbdm: 'gbdm.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        },
        {
          id: 129,
          key: 'CUSTOMER_PROJECT_MAPS',
          storedReport: 'CUSTOMER_PROJECT_MAPS',
          mapping: REPORT_129_MAPPINGS
        },
        {
          id: 129,
          key: 'CUSTOMER_PROJECT_MANAGEMENT',
          storedReport: 'CUSTOMER_PROJECT_MANAGEMENT',
          mapping: REPORT_129_MAPPINGS
        },
        {
          id: 48,
          key: 'SUCCESS_STORIES',
          storedReport: 'SUCCESS_STORIES',
          mapping: {
            Desprnm: 'customer.id',
            Decomnm: 'customerCompany.id',
            Lalamnm: 'lam.id',
            Lalname: 'lamContact.id',
            Lalamcm: 'lamCompany.id',
            Gblname: 'gbdm.id',
            Gbdm_desk: 'gbdmDesk.id'
          }
        }
      ]
    }
  ]
};

